import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { css, useTheme, jsx } from '@emotion/react';
import { utilStyles, getColorValue, ColorContext, Shimmer } from '@paypalcorp/pp-react-utils';
import { math, remToPx } from 'polished';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useMemo } from 'react';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function styles(tokens, colorTokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    console.warn('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysColorBackgroundHighContrast = tokens.sysColorBackgroundHighContrast,
      sysColorBackgroundMediumContrast = tokens.sysColorBackgroundMediumContrast,
      sysTypographyDisplayFamily = tokens.sysTypographyDisplayFamily,
      sysTypographyDisplaySize = tokens.sysTypographyDisplaySize,
      sysTypographyDisplayWeight = tokens.sysTypographyDisplayWeight,
      sysTypographyDisplayLineHeight = tokens.sysTypographyDisplayLineHeight,
      sysTypographyDisplayMaxScaleFactor = tokens.sysTypographyDisplayMaxScaleFactor,
      sysTypographyHeadingLgFamily = tokens.sysTypographyHeadingLgFamily,
      sysTypographyHeadingLgSize = tokens.sysTypographyHeadingLgSize,
      sysTypographyHeadingLgWeight = tokens.sysTypographyHeadingLgWeight,
      sysTypographyHeadingLgLineHeight = tokens.sysTypographyHeadingLgLineHeight,
      sysTypographyHeadingLgMaxScaleFactor = tokens.sysTypographyHeadingLgMaxScaleFactor,
      sysTypographyHeadingSmFamily = tokens.sysTypographyHeadingSmFamily,
      sysTypographyHeadingSmSize = tokens.sysTypographyHeadingSmSize,
      sysTypographyHeadingSmWeight = tokens.sysTypographyHeadingSmWeight,
      sysTypographyHeadingSmLineHeight = tokens.sysTypographyHeadingSmLineHeight,
      sysTypographyHeadingSmMaxScaleFactor = tokens.sysTypographyHeadingSmMaxScaleFactor,
      sysTypographyTitleStrongFamily = tokens.sysTypographyTitleStrongFamily,
      sysTypographyTitleStrongSize = tokens.sysTypographyTitleStrongSize,
      sysTypographyTitleStrongWeight = tokens.sysTypographyTitleStrongWeight,
      sysTypographyTitleStrongLineHeight = tokens.sysTypographyTitleStrongLineHeight,
      sysTypographyTitleStrongMaxScaleFactor = tokens.sysTypographyTitleStrongMaxScaleFactor,
      sysTypographyTitleFamily = tokens.sysTypographyTitleFamily,
      sysTypographyTitleSize = tokens.sysTypographyTitleSize,
      sysTypographyTitleWeight = tokens.sysTypographyTitleWeight,
      sysTypographyTitleLineHeight = tokens.sysTypographyTitleLineHeight,
      sysTypographyTitleMaxScaleFactor = tokens.sysTypographyTitleMaxScaleFactor,
      sysTypographyBodyStrongFamily = tokens.sysTypographyBodyStrongFamily,
      sysTypographyBodyStrongSize = tokens.sysTypographyBodyStrongSize,
      sysTypographyBodyStrongWeight = tokens.sysTypographyBodyStrongWeight,
      sysTypographyBodyStrongLineHeight = tokens.sysTypographyBodyStrongLineHeight,
      sysTypographyBodyStrongMaxScaleFactor = tokens.sysTypographyBodyStrongMaxScaleFactor,
      sysTypographyBodyFamily = tokens.sysTypographyBodyFamily,
      sysTypographyBodySize = tokens.sysTypographyBodySize,
      sysTypographyBodyWeight = tokens.sysTypographyBodyWeight,
      sysTypographyBodyLineHeight = tokens.sysTypographyBodyLineHeight,
      sysTypographyBodyMaxScaleFactor = tokens.sysTypographyBodyMaxScaleFactor,
      sysTypographyCaptionFamily = tokens.sysTypographyCaptionFamily,
      sysTypographyCaptionSize = tokens.sysTypographyCaptionSize,
      sysTypographyCaptionWeight = tokens.sysTypographyCaptionWeight,
      sysTypographyCaptionLineHeight = tokens.sysTypographyCaptionLineHeight,
      sysTypographyCaptionMaxScaleFactor = tokens.sysTypographyCaptionMaxScaleFactor,
      sysTypographyCaptionStrongFamily = tokens.sysTypographyCaptionStrongFamily,
      sysTypographyCaptionStrongSize = tokens.sysTypographyCaptionStrongSize,
      sysTypographyCaptionStrongWeight = tokens.sysTypographyCaptionStrongWeight,
      sysTypographyCaptionStrongLineHeight = tokens.sysTypographyCaptionStrongLineHeight,
      sysTypographyCaptionStrongMaxScaleFactor = tokens.sysTypographyCaptionStrongMaxScaleFactor,
      sysTypographyButtonLgFamily = tokens.sysTypographyButtonLgFamily,
      sysTypographyButtonLgSize = tokens.sysTypographyButtonLgSize,
      sysTypographyButtonLgWeight = tokens.sysTypographyButtonLgWeight,
      sysTypographyButtonLgLineHeight = tokens.sysTypographyButtonLgLineHeight,
      sysTypographyButtonLgMaxScaleFactor = tokens.sysTypographyButtonLgMaxScaleFactor,
      sysTypographyButtonSmFamily = tokens.sysTypographyButtonSmFamily,
      sysTypographyButtonSmSize = tokens.sysTypographyButtonSmSize,
      sysTypographyButtonSmWeight = tokens.sysTypographyButtonSmWeight,
      sysTypographyButtonSmLineHeight = tokens.sysTypographyButtonSmLineHeight,
      sysTypographyButtonSmMaxScaleFactor = tokens.sysTypographyButtonSmMaxScaleFactor,
      sysTypographyFieldLabelLgFamily = tokens.sysTypographyFieldLabelLgFamily,
      sysTypographyFieldLabelLgSize = tokens.sysTypographyFieldLabelLgSize,
      sysTypographyFieldLabelLgWeight = tokens.sysTypographyFieldLabelLgWeight,
      sysTypographyFieldLabelLgLineHeight = tokens.sysTypographyFieldLabelLgLineHeight,
      sysTypographyFieldLabelLgMaxScaleFactor = tokens.sysTypographyFieldLabelLgMaxScaleFactor,
      sysTypographyFieldLabelSmFamily = tokens.sysTypographyFieldLabelSmFamily,
      sysTypographyFieldLabelSmSize = tokens.sysTypographyFieldLabelSmSize,
      sysTypographyFieldLabelSmWeight = tokens.sysTypographyFieldLabelSmWeight,
      sysTypographyFieldLabelSmLineHeight = tokens.sysTypographyFieldLabelSmLineHeight,
      sysTypographyFieldLabelSmMaxScaleFactor = tokens.sysTypographyFieldLabelSmMaxScaleFactor,
      sysTypographyFieldValueXlFamily = tokens.sysTypographyFieldValueXlFamily,
      sysTypographyFieldValueXlSize = tokens.sysTypographyFieldValueXlSize,
      sysTypographyFieldValueXlWeight = tokens.sysTypographyFieldValueXlWeight,
      sysTypographyFieldValueXlLineHeight = tokens.sysTypographyFieldValueXlLineHeight,
      sysTypographyFieldValueXlMaxScaleFactor = tokens.sysTypographyFieldValueXlMaxScaleFactor,
      sysTypographyFieldValueLgFamily = tokens.sysTypographyFieldValueLgFamily,
      sysTypographyFieldValueLgSize = tokens.sysTypographyFieldValueLgSize,
      sysTypographyFieldValueLgWeight = tokens.sysTypographyFieldValueLgWeight,
      sysTypographyFieldValueLgLineHeight = tokens.sysTypographyFieldValueLgLineHeight,
      sysTypographyFieldValueLgMaxScaleFactor = tokens.sysTypographyFieldValueLgMaxScaleFactor,
      sysTypographyFieldValueSmFamily = tokens.sysTypographyFieldValueSmFamily,
      sysTypographyFieldValueSmSize = tokens.sysTypographyFieldValueSmSize,
      sysTypographyFieldValueSmWeight = tokens.sysTypographyFieldValueSmWeight,
      sysTypographyFieldValueSmLineHeight = tokens.sysTypographyFieldValueSmLineHeight,
      sysTypographyFieldValueSmMaxScaleFactor = tokens.sysTypographyFieldValueSmMaxScaleFactor,
      sysSizeMediaMd = tokens.sysSizeMediaMd;

  var _utilStyles = utilStyles(tokens),
      shimmerStyles = _utilStyles.shimmerStyles;

  var remToPxBase = '16px';

  function maxSizeInMWeb(size, scaleFactor) {
    var maxSize = math("".concat(size, "*").concat(scaleFactor));
    var maxSizeInPx = remToPx(maxSize, remToPxBase);
    return "min(".concat(size, ", ").concat(maxSizeInPx, ")");
  }

  function font(label, color, family, size, scaleFactor, lineHeight, fontWeight) {
    var fontFamily = "".concat(family, ", \"Helvetica Neue\", Arial, sans-serif"); // calculate screen maxwidth in px

    var mediaMdInPx = remToPx(sysSizeMediaMd, remToPxBase);
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      label: ", ";\n      color: ", ";\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n\n      @media screen and (max-width: ", ") {\n        font-size: ", ";\n        line-height: ", ";\n      }\n    "])), label, getColorValue(colorTokens, color, 'contrast'), fontFamily, size, lineHeight, fontWeight, mediaMdInPx, maxSizeInMWeb(size, scaleFactor), maxSizeInMWeb(lineHeight, scaleFactor));
  }

  function lineClamping(clampLine) {
    var clampAtLine = clampLine > 4 ? 4 : clampLine; // max 4 lines

    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      label: ", ";\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      -webkit-line-clamp: ", ";\n    "])), "line_clamp_".concat(clampAtLine), clampAtLine);
  }

  var shimmer = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    label: text_shimmer;\n    ", "\n  "])), shimmerStyles.defaults());
  var shimmerDisplay = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    label: display;\n    height: ", ";\n  "])), sysTypographyDisplayLineHeight);
  var shimmerHeadingLg = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    label: heading_lg;\n    height: ", ";\n  "])), sysTypographyHeadingLgLineHeight);
  var shimmerHeadingSm = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    label: heading_sm;\n    height: ", ";\n  "])), sysTypographyHeadingSmLineHeight);
  var shimmerBody = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    label: body;\n    height: ", ";\n  "])), sysTypographyBodyLineHeight);
  var shimmerCaption = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    label: caption;\n    height: ", ";\n  "])), sysTypographyCaptionLineHeight);
  var shimmerTitle = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    label: title;\n    height: ", ";\n  "])), sysTypographyTitleLineHeight);
  return {
    body: function body() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight = args.lineHeight,
          lineHeight = _args$lineHeight === void 0 ? sysTypographyBodyLineHeight : _args$lineHeight,
          _args$color = args.color,
          color = _args$color === void 0 ? sysColorBackgroundHighContrast : _args$color;
      return font('text_body', color, sysTypographyBodyFamily, sysTypographyBodySize, sysTypographyBodyMaxScaleFactor, lineHeight, sysTypographyBodyWeight);
    },
    bodyStrong: function bodyStrong() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight2 = args.lineHeight,
          lineHeight = _args$lineHeight2 === void 0 ? sysTypographyBodyStrongLineHeight : _args$lineHeight2,
          _args$color2 = args.color,
          color = _args$color2 === void 0 ? sysColorBackgroundHighContrast : _args$color2;
      return font('text_body_strong', color, sysTypographyBodyStrongFamily, sysTypographyBodyStrongSize, sysTypographyBodyStrongMaxScaleFactor, lineHeight, sysTypographyBodyStrongWeight);
    },
    caption: function caption() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight3 = args.lineHeight,
          lineHeight = _args$lineHeight3 === void 0 ? sysTypographyCaptionLineHeight : _args$lineHeight3,
          _args$color3 = args.color,
          color = _args$color3 === void 0 ? sysColorBackgroundHighContrast : _args$color3;
      return font('text_caption', color, sysTypographyCaptionFamily, sysTypographyCaptionSize, sysTypographyCaptionMaxScaleFactor, lineHeight, sysTypographyCaptionWeight);
    },
    captionStrong: function captionStrong() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight4 = args.lineHeight,
          lineHeight = _args$lineHeight4 === void 0 ? sysTypographyCaptionStrongLineHeight : _args$lineHeight4,
          _args$color4 = args.color,
          color = _args$color4 === void 0 ? sysColorBackgroundHighContrast : _args$color4;
      return font('text_caption_strong', color, sysTypographyCaptionStrongFamily, sysTypographyCaptionStrongSize, sysTypographyCaptionStrongMaxScaleFactor, lineHeight, sysTypographyCaptionStrongWeight);
    },
    headingSm: function headingSm() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight7 = args.lineHeight,
          lineHeight = _args$lineHeight7 === void 0 ? sysTypographyHeadingSmLineHeight : _args$lineHeight7,
          _args$color7 = args.color,
          color = _args$color7 === void 0 ? sysColorBackgroundHighContrast : _args$color7;
      return font('text_heading_sm', color, sysTypographyHeadingSmFamily, sysTypographyHeadingSmSize, sysTypographyHeadingSmMaxScaleFactor, lineHeight, sysTypographyHeadingSmWeight);
    },
    headingLg: function headingLg() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight8 = args.lineHeight,
          lineHeight = _args$lineHeight8 === void 0 ? sysTypographyHeadingLgLineHeight : _args$lineHeight8,
          _args$color8 = args.color,
          color = _args$color8 === void 0 ? sysColorBackgroundHighContrast : _args$color8;
      return font('text_heading_lg', color, sysTypographyHeadingLgFamily, sysTypographyHeadingLgSize, sysTypographyHeadingLgMaxScaleFactor, lineHeight, sysTypographyHeadingLgWeight);
    },
    display: function display() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight9 = args.lineHeight,
          lineHeight = _args$lineHeight9 === void 0 ? sysTypographyDisplayLineHeight : _args$lineHeight9,
          _args$color9 = args.color,
          color = _args$color9 === void 0 ? sysColorBackgroundHighContrast : _args$color9;
      return font('text_display', color, sysTypographyDisplayFamily, sysTypographyDisplaySize, sysTypographyDisplayMaxScaleFactor, lineHeight, sysTypographyDisplayWeight);
    },
    title: function title() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight5 = args.lineHeight,
          lineHeight = _args$lineHeight5 === void 0 ? sysTypographyTitleLineHeight : _args$lineHeight5,
          _args$color5 = args.color,
          color = _args$color5 === void 0 ? sysColorBackgroundHighContrast : _args$color5;
      return font('text_title', color, sysTypographyTitleFamily, sysTypographyTitleSize, sysTypographyTitleMaxScaleFactor, lineHeight, sysTypographyTitleWeight);
    },
    titleStrong: function titleStrong() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight6 = args.lineHeight,
          lineHeight = _args$lineHeight6 === void 0 ? sysTypographyTitleStrongLineHeight : _args$lineHeight6,
          _args$color6 = args.color,
          color = _args$color6 === void 0 ? sysColorBackgroundHighContrast : _args$color6,
          _args$label = args.label,
          label = _args$label === void 0 ? 'text_title_strong' : _args$label;
      return font(label, color, sysTypographyTitleStrongFamily, sysTypographyTitleStrongSize, sysTypographyTitleStrongMaxScaleFactor, lineHeight, sysTypographyTitleStrongWeight);
    },
    buttonLg: function buttonLg() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight11 = args.lineHeight,
          lineHeight = _args$lineHeight11 === void 0 ? sysTypographyButtonLgLineHeight : _args$lineHeight11,
          _args$color11 = args.color,
          color = _args$color11 === void 0 ? sysColorBackgroundHighContrast : _args$color11;
      return font('text_button_lg', color, sysTypographyButtonLgFamily, sysTypographyButtonLgSize, sysTypographyButtonLgMaxScaleFactor, lineHeight, sysTypographyButtonLgWeight);
    },
    buttonSm: function buttonSm() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight10 = args.lineHeight,
          lineHeight = _args$lineHeight10 === void 0 ? sysTypographyButtonSmLineHeight : _args$lineHeight10,
          _args$color10 = args.color,
          color = _args$color10 === void 0 ? sysColorBackgroundHighContrast : _args$color10;
      return font('text_button_sm', color, sysTypographyButtonSmFamily, sysTypographyButtonSmSize, sysTypographyButtonSmMaxScaleFactor, lineHeight, sysTypographyButtonSmWeight);
    },
    fieldLabelSm: function fieldLabelSm() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight12 = args.lineHeight,
          lineHeight = _args$lineHeight12 === void 0 ? sysTypographyFieldLabelSmLineHeight : _args$lineHeight12,
          _args$color12 = args.color,
          color = _args$color12 === void 0 ? sysColorBackgroundMediumContrast : _args$color12;
      return font('text_field_label_sm', color, sysTypographyFieldLabelSmFamily, sysTypographyFieldLabelSmSize, sysTypographyFieldLabelSmMaxScaleFactor, lineHeight, sysTypographyFieldLabelSmWeight);
    },
    fieldLabelLg: function fieldLabelLg() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight13 = args.lineHeight,
          lineHeight = _args$lineHeight13 === void 0 ? sysTypographyFieldLabelLgLineHeight : _args$lineHeight13,
          _args$color13 = args.color,
          color = _args$color13 === void 0 ? sysColorBackgroundMediumContrast : _args$color13;
      return font('text_field_label_lg', color, sysTypographyFieldLabelLgFamily, sysTypographyFieldLabelLgSize, sysTypographyFieldLabelLgMaxScaleFactor, lineHeight, sysTypographyFieldLabelLgWeight);
    },
    fieldValueSm: function fieldValueSm() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight14 = args.lineHeight,
          lineHeight = _args$lineHeight14 === void 0 ? sysTypographyFieldValueSmLineHeight : _args$lineHeight14,
          _args$color14 = args.color,
          color = _args$color14 === void 0 ? sysColorBackgroundHighContrast : _args$color14;
      return font('text_field_value_sm', color, sysTypographyFieldValueSmFamily, sysTypographyFieldValueSmSize, sysTypographyFieldValueSmMaxScaleFactor, lineHeight, sysTypographyFieldValueSmWeight);
    },
    fieldValueLg: function fieldValueLg() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight15 = args.lineHeight,
          lineHeight = _args$lineHeight15 === void 0 ? sysTypographyFieldValueLgLineHeight : _args$lineHeight15,
          _args$color15 = args.color,
          color = _args$color15 === void 0 ? sysColorBackgroundHighContrast : _args$color15;
      return font('text_field_value_lg', color, sysTypographyFieldValueLgFamily, sysTypographyFieldValueLgSize, sysTypographyFieldValueLgMaxScaleFactor, lineHeight, sysTypographyFieldValueLgWeight);
    },
    fieldValueXl: function fieldValueXl() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _args$lineHeight16 = args.lineHeight,
          lineHeight = _args$lineHeight16 === void 0 ? sysTypographyFieldValueXlLineHeight : _args$lineHeight16,
          _args$color16 = args.color,
          color = _args$color16 === void 0 ? sysColorBackgroundHighContrast : _args$color16;
      return font('text_field_value_xl', color, sysTypographyFieldValueXlFamily, sysTypographyFieldValueXlSize, sysTypographyFieldValueXlMaxScaleFactor, lineHeight, sysTypographyFieldValueXlWeight);
    },
    lineClamping: lineClamping,
    shimmer: shimmer,
    shimmerDisplay: shimmerDisplay,
    shimmerHeadingLg: shimmerHeadingLg,
    shimmerHeadingSm: shimmerHeadingSm,
    shimmerBody: shimmerBody,
    shimmerCaption: shimmerCaption,
    shimmerTitle: shimmerTitle
  };
}

var _excluded = ["level", "as", "size", "className", "isLoading", "isInverse", "children"];

var chooseSize = function chooseSize(level, size) {
  if (size) {
    return size;
  }

  switch (level) {
    case 1:
      return 'lg';

    case 2:
      return 'sm';

    case 3:
      return 'title';

    default:
      return 'lg';
  }
};

var HeadingText = function HeadingText(_ref) {
  var level = _ref.level,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? level ? "h".concat(level) : 'div' : _ref$as,
      size = _ref.size,
      className = _ref.className,
      isLoading = _ref.isLoading,
      isInverse = _ref.isInverse,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();
  var colorTokens = React.useContext(ColorContext);

  var _styles = useMemo(function () {
    return styles(tokens, colorTokens);
  }, [tokens, colorTokens]);

  var headingSize = chooseSize(level, size);
  var stylesMap = {
    display: _styles.display,
    hero: _styles.display,
    sm: _styles.headingSm,
    lg: _styles.headingLg,
    title: _styles.title
  };
  var shimmerStylesMap = {
    display: _styles.shimmerDisplay,
    hero: _styles.shimmerDisplay,
    sm: _styles.shimmerHeadingSm,
    lg: _styles.shimmerHeadingLg,
    title: _styles.shimmerTitle
  };

  if (isLoading) {
    return jsx(Shimmer, _extends({
      css: [_styles.shimmer, shimmerStylesMap[headingSize]],
      className: className,
      hasStyleDefaults: false,
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }

  return jsx(as, _extends({
    css: stylesMap[headingSize],
    className: className,
    "data-ppui-info": "heading-text_6.6.0"
  }, rest), children);
};

var _excluded$1 = ["as", "strong", "className", "isLoading", "isInverse", "clampAtLine", "children"];

var BodyText = function BodyText(_ref) {
  var _styles$lineClamping;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      strong = _ref.strong,
      className = _ref.className,
      isLoading = _ref.isLoading,
      isInverse = _ref.isInverse,
      clampAtLine = _ref.clampAtLine,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var tokens = useTheme();
  var colorTokens = React.useContext(ColorContext);

  var _styles = useMemo(function () {
    return styles(tokens, colorTokens);
  }, [tokens, colorTokens]);

  if (isLoading) {
    return jsx(Shimmer, _extends({
      css: [_styles.shimmer, _styles.shimmerBody],
      className: className,
      hasStyleDefaults: false,
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }

  var cssVal = [!strong && _styles.body, strong && _styles.bodyStrong, clampAtLine && ((_styles$lineClamping = _styles.lineClamping) === null || _styles$lineClamping === void 0 ? void 0 : _styles$lineClamping.call(_styles, clampAtLine))];
  return jsx(as, _extends({
    css: cssVal,
    className: className,
    "data-ppui-info": "body-text_6.6.0"
  }, rest), children);
};

var _excluded$2 = ["as", "strong", "clampAtLine", "className", "isLoading", "isInverse", "children"];

var CaptionText = function CaptionText(_ref) {
  var _styles$lineClamping;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      strong = _ref.strong,
      clampAtLine = _ref.clampAtLine,
      className = _ref.className,
      isLoading = _ref.isLoading,
      isInverse = _ref.isInverse,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var tokens = useTheme();
  var colorTokens = React.useContext(ColorContext);

  var _styles = useMemo(function () {
    return styles(tokens, colorTokens);
  }, [tokens, colorTokens]);

  if (isLoading) {
    return jsx(Shimmer, _extends({
      css: [_styles.shimmer, _styles.shimmerCaption],
      className: className,
      hasStyleDefaults: false,
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }

  var cssVal = [!strong && _styles.caption, strong && _styles.captionStrong, clampAtLine && ((_styles$lineClamping = _styles.lineClamping) === null || _styles$lineClamping === void 0 ? void 0 : _styles$lineClamping.call(_styles, clampAtLine))];
  return jsx(as, _extends({
    css: cssVal,
    className: className,
    "data-ppui-info": "caption-text_6.6.0"
  }, rest), children);
};

export { BodyText, CaptionText, HeadingText, styles as textStyles };